import { selectLastCopyId } from '../../../domain'

import { useAppState } from '../State'

export const useIsItemCopied = (children: React.ReactNode): boolean => useAppState((s) => selectLastCopyId(s) === children, [children])
